import { config } from "../config";

type LocalizeApi = {
	initialize: (opts: Record<string, unknown>) => void;
};

function getLocalize(): LocalizeApi | undefined {
	if (typeof window === "undefined") return undefined;
	const L = (window as unknown as { Localize?: LocalizeApi }).Localize;
	return L && typeof L.initialize === "function" ? L : undefined;
}

export function effectiveLocalizeProjectKey(
	reseller: T.Schema.Reseller.ResellerSchema | null | undefined,
	org: T.Schema.Organisation.OrganisationSchema | null | undefined
): string {
	const resellerKey = (reseller?.translation_api_key ?? "").trim();
	if (resellerKey.length > 0) return resellerKey;
	const orgKey = (org?.translation_api_key ?? "").trim();
	return orgKey.length > 0 ? orgKey : "7Oh6XePjWnViX";
}

let lastSyncedEffectiveKey: string | null = null;

/**
 * Initializes Localize.js using the reseller key if set, otherwise the organisation's
 * optional project key, otherwise the CloudWaitress default. Data is only available
 * at runtime (after login), not at webpack/template build time.
 */
export function syncDashboardLocalize(
	reseller: T.Schema.Reseller.ResellerSchema | null | undefined,
	org: T.Schema.Organisation.OrganisationSchema | null | undefined
): void {
	const Localize = getLocalize();
	if (!Localize) return;

	const key = effectiveLocalizeProjectKey(reseller, org);
	if (lastSyncedEffectiveKey === key) return;

	if (lastSyncedEffectiveKey !== null) {
		window.location.reload();
		return;
	}

	lastSyncedEffectiveKey = key;
	Localize.initialize({
		key,
		rememberLanguage: true,
		saveNewPhrases: false,
	});
}
